import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import AppointmentMain from "./AppointmentMain";
import Footer from "../../components/Footer";

const Appointment = () => {
  return (
    <>
      <HeaderFour />

      <AppointmentMain />

      <Footer />
    </>
  );
};

export default Appointment;
